module.exports = __webpack_public_path__ + "img/DIS Antiquité FR Profile.43498348.webp";